import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SignatureStatsTable.css';

/**
 * Tableau des statistiques par signature
 * @param {Array} signatures - Liste des signatures [{id, name, impressions, clicks, ctr}, ...]
 * @param {string} title - Titre du tableau
 */
function SignatureStatsTable({ signatures = [], title = 'Statistiques par signature' }) {
    const navigate = useNavigate();

    const handleRowClick = (signatureId) => {
        navigate(`/statistics/${signatureId}`);
    };

    if (!signatures || signatures.length === 0) {
        return (
            <div className="signature-stats-table empty">
                <h3>{title}</h3>
                <p className="empty-message">Aucune signature avec des statistiques</p>
            </div>
        );
    }

    return (
        <div className="signature-stats-table">
            <h3>{title}</h3>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th className="col-name">Signature</th>
                            <th className="col-impressions">Impressions</th>
                            <th className="col-clicks">Clics</th>
                            <th className="col-ctr">CTR</th>
                        </tr>
                    </thead>
                    <tbody>
                        {signatures.map((sig) => (
                            <tr
                                key={sig.id}
                                onClick={() => handleRowClick(sig.id)}
                                className="clickable"
                            >
                                <td className="col-name">
                                    <span className="signature-name">{sig.name}</span>
                                </td>
                                <td className="col-impressions">
                                    <span className="stat-value">{sig.impressions.toLocaleString('fr-FR')}</span>
                                </td>
                                <td className="col-clicks">
                                    <span className="stat-value">{sig.clicks.toLocaleString('fr-FR')}</span>
                                </td>
                                <td className="col-ctr">
                                    <span className={`ctr-badge ${getCtrClass(sig.ctr)}`}>
                                        {sig.ctr}%
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

// Détermine la classe CSS du CTR selon sa valeur
function getCtrClass(ctr) {
    if (ctr >= 15) return 'excellent';
    if (ctr >= 10) return 'good';
    if (ctr >= 5) return 'average';
    return 'low';
}

export default SignatureStatsTable;
